// src/components/pages/company/PlanRequerido.tsx
//
// Pantalla que se muestra cuando la empresa intenta entrar a una pantalla
// de operativa sin tener plan efectivo activo (periodo gratuito terminado
// o sin plan contratado). Invita a contratar desde Suscripción.

import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function PlanRequerido() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-20 text-center max-w-md mx-auto">
      <div className="flex items-center justify-center w-14 h-14 rounded-full bg-amber-50 dark:bg-amber-900/20 mb-4">
        <Lock className="w-6 h-6 text-amber-600 dark:text-amber-400" />
      </div>

      <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
        Necesitas un plan activo
      </h2>

      <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed mb-6">
        Tu periodo gratuito ha terminado o todavía no tienes un plan
        contratado. Contrata uno para volver a acceder a todas las funciones
        de tu panel.
      </p>

      <Button
        onClick={() => navigate('/panel-empresa/subscriptions')}
        className="rounded-xl text-white hover:opacity-90"
        style={{ backgroundColor: '#288E7F' }}
      >
        Ver planes disponibles
      </Button>
    </div>
  );
}